import { Inject, Injectable, Optional } from '@angular/core';
import {
  DashboardCardService,
  DashboardCard,
  SalesSummaryCardComponent,
  LastVsThisYearSalesAmountSummaryCardComponent,
  LastVsThisMonthSalesAmountSummaryCardComponent,
  LastVsThisWeekSalesAmountSummaryCardComponent,
  LastSevenDaysOrdersSummaryCardComponent,
  InvoiceStatisticsChartCardComponent
} from 'gung-dashboard';
import { AuthService, NavigationConfig } from 'gung-standard';
import { map } from 'rxjs';
import { ColmecInvoiceStatisticsChartCardComponent } from '../components/colmec-invoice-statistics-chart-card/colmec-invoice-statistics-chart-card.component';
import { ColmecSalespersonSelectComponent } from '../components/colmec-salesperson-select/colmec-salesperson-select.component';
import { ColmecLastSevenDaysOrdersSummaryCardComponent } from '../components/dashboard/colmec-last-seven-days-orders-summary-card/colmec-last-seven-days-orders-summary-card.component';
import { ColmecLastVsThisMonthSalesAmountSummaryCardComponent } from '../components/dashboard/colmec-last-vs-this-month-sales-amount-summary-card/colmec-last-vs-this-month-sales-amount-summary-card.component';
import { ColmecLastVsThisWeekSalesAmountSummaryCardComponent } from '../components/dashboard/colmec-last-vs-this-week-sales-amount-summary-card/colmec-last-vs-this-week-sales-amount-summary-card.component';
import { ColmecLastVsThisYearSalesAmountSummaryCardComponent } from '../components/dashboard/colmec-last-vs-this-year-sales-amount-summary-card/colmec-last-vs-this-year-sales-amount-summary-card.component';
import { ColmecSalesSummaryCardComponent } from '../components/dashboard/colmec-sales-summary-card/colmec-sales-summary-card.component';
import { ColmecDashboardDataService } from './colmec-dashboard-data.service';

@Injectable({
  providedIn: 'root'
})
export class ColmecDashboardCardService extends DashboardCardService {
  constructor(
    protected authService: AuthService,
    protected dashboardDataService: ColmecDashboardDataService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(authService, environment);
    authService
      .getHasRoles('SALES')
      .pipe(
        map(isAdmin => {
          dashboardDataService.currentMessage.subscribe(preCondition => {
            this.clearCards();
            this.addCard(
              new DashboardCard(ColmecLastVsThisYearSalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3')
            );
            this.addCard(
              new DashboardCard(ColmecLastVsThisMonthSalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3')
            );
            this.addCard(
              new DashboardCard(ColmecLastVsThisWeekSalesAmountSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3')
            );
            this.addCard(
              new DashboardCard(ColmecLastSevenDaysOrdersSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3')
            );

            if (isAdmin) {
              this.addCard(
                new DashboardCard(ColmecSalespersonSelectComponent, 'col-xs-12 col-md-12 col-xl-12', preCondition)
              );
            }
            if (preCondition) {
              this.addCard(
                new DashboardCard(
                  LastVsThisYearSalesAmountSummaryCardComponent,
                  'col-xs-12 col-md-6 col-xl-3',
                  preCondition
                )
              );
              this.addCard(
                new DashboardCard(
                  LastVsThisMonthSalesAmountSummaryCardComponent,
                  'col-xs-12 col-md-6 col-xl-3',
                  preCondition
                )
              );
              this.addCard(
                new DashboardCard(
                  LastVsThisWeekSalesAmountSummaryCardComponent,
                  'col-xs-12 col-md-6 col-xl-3',
                  preCondition
                )
              );
              this.addCard(
                new DashboardCard(LastSevenDaysOrdersSummaryCardComponent, 'col-xs-12 col-md-6 col-xl-3', preCondition)
              );
            }
            this.addCard(
              new DashboardCard(
                ColmecInvoiceStatisticsChartCardComponent,
                'col-xs-12 col-md-12 col-xl-12',
                preCondition
              )
            );
            this.addCard(new DashboardCard(ColmecSalesSummaryCardComponent, 'col-xs-12 col-md-12 col-xl-12'));
          });
        })
      )
      .subscribe();
  }
}
